<template>
  <div class="main-width-page">
    <!-- 左侧图片 -->
    <div class="left-width-images">
      <img ref="width-img1" style="z-index: 3;margin-top:-200px;margin-left: -50px "
           src="../../static/series/evo/weight_one.png" alt="">
      <img ref="width-img2" style="margin-top:-100px;z-index: 2 ;margin-left: -30px "
           src="../../static/series/evo/weight_two.png" alt="">
      <img ref="width-img3" style="z-index: 1" src="../../static/series/evo/weight_three.png" alt="">
    </div>
    <!-- 右侧文字部分 -->
    <div class="right-width-text">
      <div class="right-width-main">
        <div class="right-width-top1">
          <div style="border-top: 2px solid #333; width: 35px">
            <span>XX18</span>
          </div>
          <div>
            <span class="width-length" style="font-size: var(--font-size-xl)">1.8m<span
                style="color: #808080;font-size: 20px">{{ $t('series.maxCuttingWidth') }}</span></span>
          </div>
        </div>
        <div class="right-width-top2">
          <div style="border-top: 2px solid #333; width: 35px">
            <span>XX18</span>
          </div>
          <div>
            <span class="width-length" style="font-size: var(--font-size-xl)">2.0m<span
                style="color: #808080;font-size: 20px">{{ $t('series.maxCuttingWidth') }}</span></span>
          </div>
        </div>
        <div class="right-width-top3">
          <div style="border-top: 2px solid #333; width: 35px">
            <span>XX18</span>
          </div>
          <div>
            <span class="width-length" style="font-size: var(--font-size-xl)">2.2m<span
                style="color: #808080;font-size: 20px">{{ $t('series.maxCuttingWidth') }}</span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidthPage',
  data() {
    return {
      isMobile: false
    }
  },
  methods: {
    checkDevice() {
      this.isMobile = window.innerWidth <= 768;
    },
    handleResize() {
      this.checkDevice();
    }
  },
  mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.handleResize);

    this.$nextTick(() => {
      // 计算缩放比例（手机端为0.6，保持与电脑端比例一致）
      const scaleRatio = this.isMobile ? 0.6 : 1;

      // 统一动画参数（按比例缩放）
      const animParams = {
        img1Y: 200 * scaleRatio,
        img1X: 100 * scaleRatio,
        img2Y: 150 * scaleRatio,
        img2X: 50 * scaleRatio,
        textY: 100 * scaleRatio,
        exitY: -300 * scaleRatio,
        duration: 2 * scaleRatio,
        scrub: 2 * scaleRatio,
        startTrigger: this.isMobile ? 'top 90%' : 'top 120%',
        endTrigger: this.isMobile ? 'bottom 20%' : 'bottom 10%'
      }

      this.$gsap.set([this.$refs["width-img1"], this.$refs["width-img2"], this.$refs["width-img3"]], {
        visibility: 'visible'
      });

      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: this.isMobile ? '.main-width-page' : [this.$refs["width-img1"], this.$refs["width-img2"], this.$refs["width-img3"], '.right-width-main'],
          start: animParams.startTrigger,
          end: animParams.endTrigger,
          markers: false,
          // scrub: animParams.scrub,
          toggleActions: 'play none none none'
        }
      })

      // 保持与电脑端完全一致的动画序列
      masterTimeline
          .from([this.$refs["width-img1"]], {
            y: animParams.img1Y,
            x: animParams.img1X,
            duration: animParams.duration,
            ease: 'power2.out'
          }, 0)
          .from([this.$refs["width-img2"]], {
            y: animParams.img2Y,
            x: animParams.img2X,
            duration: animParams.duration,
            ease: 'power2.out'
          }, 0)
          .from([this.$refs["width-img3"]], {
            y: 0,
            duration: animParams.duration,
            ease: 'power2.out'
          }, 0)
          .from('.right-width-main', {
            opacity: 0,
            y: animParams.textY,
            duration: animParams.duration,
            ease: 'power2.out'
          }, 0.3)
          // .to(['.main-width-page'], {
          //   y: animParams.exitY,
          //   duration: 2.5 * scaleRatio,
          //   ease: 'power3.out'
          // })
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style scoped>
.main-width-page {
  height: 900px;
  width: 100%;
  position: relative;
  top: 150px;
}

.left-width-images {
  display: flex;
  width: 50%;
  justify-content: center;

  img {
    position: absolute;
    height: 80%;
    width: 100%;
    object-fit: contain; /* 保持图片完整比例 */
  }
}

.right-width-text {
  width: 50%;
  position: absolute;
  margin-top: 170px;
  right: 100px;

  img {
    height: 100%;
    width: 40%;
  }
}

.right-width-main {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.right-width-top1 {
  margin-bottom: 50px;
}

.right-width-top2 {
  margin-left: 100px;
  margin-bottom: 50px;
}

.right-width-top3 {
  margin-left: 200px;
  margin-bottom: 50px;
}

.width-length {
  font-size: var(--font-size-lg);
}

/* 平板适配 - 介于手机和桌面之间的屏幕 */
@media (min-width: 769px) and (max-width: 1024px) {
}

/* 手机端适配 - 重点缩小字体 */
@media (max-width: 768px) {
  .main-width-page {
    height: calc(900px * 0.6); /* 按60%比例缩小高度 */
    top: calc(150px * 0.6); /* 顶部距离按比例缩小 */
    min-width: 320px; /* 确保小屏幕不挤压 */
    box-sizing: border-box;
  }

  /* 左侧图片区域保持50%宽度，与电脑端一致 */
  .left-width-images {
    width: 50%;
    justify-content: center;
  }

  .left-width-images img {
    height: 80%; /* 保持高度比例 */
    width: 100%; /* 保持宽度比例 */
  }

  /* 图片位置按比例缩小偏移量 */
  .left-width-images img:nth-child(1) {
    margin-top: calc(-200px * 0.6) !important;
    margin-left: calc(-50px * 0.6) !important;
  }

  .left-width-images img:nth-child(2) {
    margin-top: calc(-100px * 0.6) !important;
    margin-left: calc(-30px * 0.6) !important;
  }

  /* 右侧文字区域保持50%宽度，与电脑端一致 */
  .right-width-text {
    width: 70%;
    position: absolute;
    margin-top: calc(170px * 0.6); /* 上边距按比例缩小 */
    right: calc(100px * 0.6); /* 右边距按比例缩小 */
    padding-left: 0; /* 移除错误的左内边距 */
  }

  /* 文字块间距和偏移按比例缩小 */
  .right-width-top1 {
    margin-bottom: calc(50px * 0.6);
  }

  .right-width-top2 {
    margin-left: calc(100px * 0.6);
    margin-bottom: calc(50px * 0.6);
  }

  .right-width-top3 {
    margin-left: calc(200px * 0.6);
    margin-bottom: calc(50px * 0.6);
  }

  /* 重点调整：主文字进一步缩小（原0.6→0.5） */
  .width-length {
    font-size: calc(var(--font-size-lg) * 0.5);
  }

  /* 重点调整：单位文字进一步缩小（原0.6→0.45） */
  .width-length span {
    font-size: calc(20px * 0.45) !important;
    margin-left: calc(8px * 0.6); /* 间距按比例缩小 */
  }

  /* 下划线文字进一步缩小 */
  .right-width-top1 div:first-child span,
  .right-width-top2 div:first-child span,
  .right-width-top3 div:first-child span {
    font-size: calc(1em * 0.5);
  }

  /* 下划线宽度按比例缩小 */
  .right-width-top1 div:first-child,
  .right-width-top2 div:first-child,
  .right-width-top3 div:first-child {
    width: calc(35px * 0.6) !important;
  }
}

/* 小屏手机进一步缩小字体 */
@media (max-width: 480px) {
  .main-width-page {
    height: calc(900px * 0.5);
    top: calc(150px * 0.5);
  }

  .left-width-images img:nth-child(1) {
    margin-top: calc(-200px * 0.5) !important;
    margin-left: calc(-50px * 0.5) !important;
  }

  .left-width-images img:nth-child(2) {
    margin-top: calc(-100px * 0.5) !important;
    margin-left: calc(-30px * 0.5) !important;
  }

  .right-width-text {
    margin-top: calc(0px * 0.5);
    right: calc(-10px * 0.5);
  }

  .right-width-top2 {
    margin-left: calc(100px * 0.5);
  }

  .right-width-top3 {
    margin-left: calc(200px * 0.5);
  }

  /* 小屏手机字体再缩小 */
  .width-length {
    font-size: calc(var(--font-size-lg) * 0.4);
  }

  .width-length span {
    font-size: calc(20px * 0.4) !important;
  }

  .right-width-top1 div:first-child span,
  .right-width-top2 div:first-child span,
  .right-width-top3 div:first-child span {
    font-size: calc(1em * 0.4);
  }
}
</style>
